import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { useSite } from "@/context/SiteContext";
import { useUI } from "@/context/UIContext";
import { LLink } from "@/components/common";
import { BOOKING_URL, trackBookingClick } from "@/lib/booking";

export function MobileBar() {
  const { t, lang } = useLang();
  const { settings } = useSite();
  const { menuOpen } = useUI();
  return (
    <div data-testid="mobile-sticky-bar" className={`fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-line bg-sand/95 backdrop-blur-xl md:hidden ${menuOpen ? "hidden" : ""}`} style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <a href={`tel:${settings.phone_href || "+34937745160"}`} data-testid="mobile-bar-call" className="flex flex-col items-center justify-center gap-1 py-3 font-mono text-[10px] uppercase tracking-[0.18em] text-charcoal/80">
        <Phone size={16} strokeWidth={1.5} />
        {t.nav.call}
      </a>
      <LLink to="location" data-testid="mobile-bar-location" className="flex flex-col items-center justify-center gap-1 py-3 font-mono text-[10px] uppercase tracking-[0.18em] text-charcoal/80 border-x border-line">
        <MapPin size={16} strokeWidth={1.5} />
        {t.nav.map}
      </LLink>
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-book" onClick={() => trackBookingClick("mobile-bar-book", lang)} className="flex items-center justify-center gap-2 bg-charcoal py-3 font-mono text-[10px] uppercase tracking-[0.18em] text-sand">
        {t.nav.bookShort}
        <ArrowUpRight size={13} strokeWidth={1.5} />
      </a>
    </div>
  );
}
